import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { TIMELINE_MODES, TimelineMode } from "@/constants/timeline-modes";

interface TimelineModeSwitcherProps {
  selectedMode: TimelineMode;
  onModeChange: (mode: TimelineMode) => void;
  onCustomModeSelected?: () => void; // Callback quando custom é selecionado
}

export function TimelineModeSwitcher({ selectedMode, onModeChange, onCustomModeSelected }: TimelineModeSwitcherProps) {
  const selectedLabel = TIMELINE_MODES.find(m => m.value === selectedMode)?.label || "Modo";

  const handleModeChange = (mode: TimelineMode) => {
    onModeChange(mode);
    // Notificar quando custom é selecionado
    if (mode === "custom") {
      onCustomModeSelected?.();
    }
  };

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs font-medium text-gray-600">🎯 Modo:</span>
      <Select value={selectedMode} onValueChange={handleModeChange}>
        <SelectTrigger className="h-8 w-40 text-xs">
          <SelectValue placeholder={selectedLabel} />
        </SelectTrigger>
        <SelectContent>
          {TIMELINE_MODES.map((mode) => (
            <SelectItem key={mode.value} value={mode.value} className="text-xs">
              {mode.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
